module.exports = __webpack_public_path__ + "img/icon-16-close-hover.84330b6d.svg";